import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { MedicoService } from './../../../shared/servicio/medico/medico.service';
import swal from 'sweetalert2';
import { HelpersService } from 'src/app/shared/servicio/helpers/helpers.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-add-formula',
  templateUrl: './add-formula.component.html',
  styleUrls: ['./add-formula.component.css'],
})
export class AddFormulaComponent implements OnInit {
  constructor(private medic: MedicoService, public _helper: HelpersService) { }

  productsModal: any;
  diagnosticosModal: any;
  nombreCompleto: string;
  entidad = '';
  product_id: number;
  productosmedicos: Array<Object> = [];
  diagnosticosmedicos: any = [];
  productosMedicos: any = [];
  pacienteConsultado: any = [];
  prod;
  arrayBlue = [];
  prod2;
  arrayBlue2 = [];

  @Input() medicM: any;

  email: string = 'mefidemail@binar10.co';
  description: string;
  paciente: string;
  emailPattern = '^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$';
  modalRef: BsModalRef;

  @Output() reloadFormula = new EventEmitter();

  // Nueva propiedad para controlar si el paciente es válido
  isPacienteValido: boolean = false;

  // Estados de carga para los typeahead
  isLoadingProducts: boolean = false;
  isLoadingDiagnostics: boolean = false;

  // Subjects para debounce
  private productSearchSubject = new Subject<string>();
  private diagnosticSearchSubject = new Subject<string>();

  // Control de búsqueda mejorado
  lastDiagnosticSearchTerm: string = '';
  lastProductSearchTerm: string = '';
  showProductDropdown: boolean = false;
  showDiagnosticDropdown: boolean = false;

  async ngOnInit() {
    console.log(this.medicM);
    this.setupSearchDebounce();
  }

  // Configurar debounce para las búsquedas
  private setupSearchDebounce() {
    // Debounce para productos
    this.productSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.performProductSearch(searchTerm);
    });

    // Debounce para diagnósticos
    this.diagnosticSearchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(searchTerm => {
      this.performDiagnosticSearch(searchTerm);
    });
  }

  guardarFormula() { }

  changeTypeaheadLoading() {
    this.product_id = null;
  }

  // NUEVA: Búsqueda de productos con debounce
  private async performProductSearch(searchTerm: string) {
    if (!this.medicM.idmedic || !this.isPacienteValido) {
      this.productosmedicos = [];
      return;
    }

    if (searchTerm.trim().length < 2) {
      this.productosmedicos = [];
      this.showProductDropdown = false;
      return;
    }

    // Evitar búsquedas repetidas
    if (this.lastProductSearchTerm === searchTerm.trim()) {
      return;
    }

    this.lastProductSearchTerm = searchTerm.trim();
    this.isLoadingProducts = true;
    console.log('Buscando productos con término:', searchTerm);

    try {
      const data: any = await this.medic.productsMedic(searchTerm).toPromise();
      this.productosmedicos = data.response.data || [];
      this.showProductDropdown = this.productosmedicos.length > 0;
      console.log('Productos encontrados:', this.productosmedicos.length);
    } catch (error) {
      console.error('Error al obtener productos:', error);
      this._helper.modalError('Error al obtener los productos del médico.');
      this.productosmedicos = [];
      this.showProductDropdown = false;
    } finally {
      this.isLoadingProducts = false;
    }
  }

  // NUEVA: Búsqueda de diagnósticos con debounce
  private async performDiagnosticSearch(searchTerm: string) {
    if (!this.isPacienteValido) {
      this.diagnosticosmedicos = [];
      return;
    }

    if (!searchTerm || searchTerm.trim().length < 2) {
      this.diagnosticosmedicos = [];
      this.showDiagnosticDropdown = false;
      return;
    }

    // Evitar búsquedas repetidas
    if (this.lastDiagnosticSearchTerm === searchTerm.trim()) {
      return;
    }

    this.lastDiagnosticSearchTerm = searchTerm.trim();
    this.isLoadingDiagnostics = true;
    console.log('Buscando diagnósticos con término:', searchTerm);

    try {
      const data: any = await this.medic.diagnosticos(searchTerm).toPromise();
      console.log('Diagnósticos obtenidos:', data);
      this.diagnosticosmedicos = data.results || [];
      this.showDiagnosticDropdown = this.diagnosticosmedicos.length > 0;
      console.log('Diagnósticos procesados:', this.diagnosticosmedicos.length);
    } catch (error) {
      console.error('Error al obtener diagnósticos:', error);
      this.diagnosticosmedicos = [];
      this.showDiagnosticDropdown = false;
    } finally {
      this.isLoadingDiagnostics = false;
    }
  }

  // MEJORADO: Input de productos
  onProductInput(event: any) {
    if (!this.isPacienteValido) return;

    const searchValue = event.target.value;
    this.productsModal = searchValue;

    if (searchValue.length >= 2) {
      this.productSearchSubject.next(searchValue);
    } else {
      this.productosmedicos = [];
      this.showProductDropdown = false;
    }
  }

  // MEJORADO: Input de diagnósticos
  onDiagnosticInput(event: any) {
    if (!this.isPacienteValido) return;

    const searchValue = event.target.value;
    this.diagnosticosModal = searchValue;

    if (searchValue.length >= 2) {
      this.diagnosticSearchSubject.next(searchValue);
    } else {
      this.diagnosticosmedicos = [];
      this.showDiagnosticDropdown = false;
    }
  }

  // CORREGIDA: Función que consume el servicio con parámetro name (mantener para compatibilidad)
  async productsMedics(name: string = '') {
    if (!name && this.productsModal) {
      name = this.productsModal;
    }
    this.productSearchSubject.next(name);
  }

  // CORREGIDA: Función de diagnósticos (mantener para compatibilidad)
  async diagnosticos() {
    if (this.diagnosticosModal) {
      this.diagnosticSearchSubject.next(this.diagnosticosModal);
    }
  }

  onSelect(data: Object) {
    if (!this.isPacienteValido) return;

    this.arrayBlue.push({
      ...data['item'],
      quantity: 1,
      dose_quantity: 1,
      days: 1,
      interval: 1,
      via: '',
      fraction: 1,
      presentation: '',
      description: '',
    });

    // Limpiar búsqueda
    this.productsModal = '';
    this.productosmedicos = [];
    this.showProductDropdown = false;
    this.lastProductSearchTerm = '';
  }

  onSelect2(data: Object) {
    if (!this.isPacienteValido || !data['item']) return;

    this.arrayBlue2.push(data['item']);

    // Limpiar búsqueda
    this.diagnosticosModal = '';
    this.diagnosticosmedicos = [];
    this.showDiagnosticDropdown = false;
    this.lastDiagnosticSearchTerm = '';
  }

  // NUEVA: Validación de fórmula completa
  private validarFormula(): boolean {
    if (!this.isPacienteValido) {
      this._helper.modalError('Debe consultar un paciente válido antes de crear la fórmula.');
      return false;
    }

    if (!this.arrayBlue || this.arrayBlue.length === 0) {
      this._helper.modalError('Debe agregar al menos un producto para crear la fórmula.');
      return false;
    }

    if (!this.arrayBlue2 || this.arrayBlue2.length === 0) {
      this._helper.modalError('Debe agregar al menos un diagnóstico para crear la fórmula.');
      return false;
    }

    // Validar que todos los productos tengan los campos obligatorios
    for (let i = 0; i < this.arrayBlue.length; i++) {
      const producto = this.arrayBlue[i];
      if (!producto.presentation || producto.presentation === '') {
        this._helper.modalError(`Debe seleccionar la presentación para el producto: ${producto.product_name}`);
        return false;
      }
      if (!producto.via || producto.via === '') {
        this._helper.modalError(`Debe seleccionar la vía para el producto: ${producto.product_name}`);
        return false;
      }
      if (!producto.quantity || producto.quantity <= 0) {
        this._helper.modalError(`Debe especificar una cantidad válida para el producto: ${producto.product_name}`);
        return false;
      }
      if (!producto.days || producto.days <= 0) {
        this._helper.modalError(`Debe especificar días válidos para el producto: ${producto.product_name}`);
        return false;
      }
      if (!producto.interval || producto.interval <= 0) {
        this._helper.modalError(`Debe especificar intervalos válidos para el producto: ${producto.product_name}`);
        return false;
      }
    }

    return true;
  }

  // CORREGIDA: Función crear con validación
  crear() {
    if (!this.validarFormula()) {
      return;
    }

    this.medic
      .crearFormula(
        this.medicM.idmedic,
        this.pacienteConsultado.id,
        this.email,
        this.description,
        this.arrayBlue2,
        this.arrayBlue
      )
      .toPromise()
      .then((data: any) => {
        console.log(data);

        swal({
          title:
            '<img src="assets/icons/good.png" width="80px" style="margin-top:0px;">',
          html: 'Fórmula creada exitosamente',
          confirmButtonText:
            '<p style="margin-top:0px; margin-bottom:0px; font-family: "coolvetica"; ">Acepto</p>',
          confirmButtonColor: '#6eceee',
        });

        // Limpiar formulario después de crear
        this.limpiarFormulario();
        this.reloadFormula.emit('r');
      })
      .catch((error) => {
        this._helper.modalError(error.error.error || 'Error al crear la fórmula');
      });
  }

  buscarpaciente() {
    if (!this.paciente || this.paciente.trim() === '') {
      this._helper.modalError('Debe ingresar un documento de paciente');
      return;
    }

    this.medic
      .buscarPaciente(this.paciente)
      .toPromise()
      .then((data: any) => {
        console.log(data);
        this.pacienteConsultado = data;
        this.nombreCompleto = data['first_name'] + ' ' + data['last_name'];

        // Habilitar campos después de encontrar paciente válido
        this.isPacienteValido = true;
      })
      .catch((error) => {
        this._helper.modalError('Paciente no encontrado');

        // Deshabilitar campos y limpiar datos si no se encuentra el paciente
        this.limpiarFormulario();
      });
  }

  // NUEVA: Método para limpiar formulario
  private limpiarFormulario() {
    this.isPacienteValido = false;
    this.pacienteConsultado = [];
    this.nombreCompleto = '';
    this.arrayBlue = [];
    this.arrayBlue2 = [];
    this.description = '';
    this.productsModal = '';
    this.diagnosticosModal = '';
    this.productosmedicos = [];
    this.diagnosticosmedicos = [];
    this.lastDiagnosticSearchTerm = '';
    this.lastProductSearchTerm = '';
    this.showProductDropdown = false;
    this.showDiagnosticDropdown = false;
    this.isLoadingProducts = false;
    this.isLoadingDiagnostics = false;
  }

  // Método para limpiar todo cuando cambie la cédula
  onCedulaChange() {
    this.limpiarFormulario();
  }

  // NUEVA: Método para eliminar producto
  eliminarProducto(index: number) {
    if (index >= 0 && index < this.arrayBlue.length) {
      this.arrayBlue.splice(index, 1);
    }
  }

  // NUEVA: Método para eliminar diagnóstico
  eliminarDiagnostico(index: number) {
    if (index >= 0 && index < this.arrayBlue2.length) {
      this.arrayBlue2.splice(index, 1);
    }
  }

  // NUEVA: Getter para habilitar/deshabilitar botón de crear
  get puedeCrearFormula(): boolean {
    return this.isPacienteValido &&
      this.arrayBlue.length > 0 &&
      this.arrayBlue2.length > 0;
  }

  // NUEVA: Método para cerrar dropdown al hacer clic fuera
  onProductBlur() {
    setTimeout(() => {
      this.showProductDropdown = false;
    }, 200);
  }

  onDiagnosticBlur() {
    setTimeout(() => {
      this.showDiagnosticDropdown = false;
    }, 200);
  }

  // NUEVA: Método para mostrar dropdown al hacer focus
  onProductFocus() {
    if (this.isPacienteValido && this.productosmedicos.length > 0) {
      this.showProductDropdown = true;
    }
  }

  onDiagnosticFocus() {
    if (this.isPacienteValido && this.diagnosticosmedicos.length > 0) {
      this.showDiagnosticDropdown = true;
    }
  }
}
